import { imageAsset } from './menuImages';
import { getProductTierRecipe } from '../data/productTiers';

const resolveUrl = (mod) => (mod && mod.default) || mod;

function loadTierCatalog() {
  const catalog = {};

  try {
    const ctx = require.context(
      './images/optimized/product-tiers',
      false,
      /[\w-]+-tier-\d+\.(webp|png)$/
    );

    ctx.keys().forEach((key) => {
      const match = key.match(/\.\/([\w-]+)-tier-(\d+)\.(webp|png)$/);
      if (!match) return;

      const [, productId, tierIndex, ext] = match;
      catalog[productId] = catalog[productId] || {};
      catalog[productId][tierIndex] = catalog[productId][tierIndex] || {};
      catalog[productId][tierIndex][ext === 'webp' ? 'webp' : 'png'] = resolveUrl(ctx(key));
    });
  } catch {
    return {};
  }

  Object.keys(catalog).forEach((productId) => {
    Object.keys(catalog[productId]).forEach((tierIndex) => {
      const entry = catalog[productId][tierIndex];
      if (entry.webp && entry.png) {
        catalog[productId][tierIndex] = imageAsset(entry.webp, entry.png);
      }
    });
  });

  return catalog;
}

const tierCatalog = loadTierCatalog();

export function getProductTierSlides(productId) {
  const recipe = getProductTierRecipe(productId);
  if (!recipe) return [];

  const productTiers = tierCatalog[productId] || {};

  return recipe
    .map((tier, index) => {
      const image = productTiers[String(index + 1)];
      if (!image) return null;
      return { label: tier.label, image };
    })
    .filter(Boolean);
}
